import { useState, useEffect } from 'react'
import { Button, Select, DatePicker, Form, Modal } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSave, faTimes, faCalendarAlt } from '@fortawesome/free-solid-svg-icons'
import dayjs from 'dayjs'
import 'dayjs/locale/es'
import locale from 'antd/es/date-picker/locale/es_ES'

dayjs.locale('es')

export function AsistenciaForm({
  open,
  onClose,
  onSave,
  asistencia,
  participante,
  tematicas,
  loading
}) {
  const [form] = Form.useForm()
  const [formData, setFormData] = useState({
    oid_matriculado: participante.oid,
    oid_tematica: 1,
    participa: 1,
    fecha: dayjs()
  })

  const [errors, setErrors] = useState({})

  useEffect(() => {
    if (asistencia) {
      setFormData({
        oid_matriculado: asistencia.oid_matriculado,
        oid_tematica: asistencia.oid_tematica,
        participa: asistencia.participa,
        fecha: dayjs(asistencia.fecha)
      })
      form.setFieldsValue({
        oid_tematica: asistencia.oid_tematica,
        participa: asistencia.participa,
        fecha: dayjs(asistencia.fecha)
      })
    } else {
      setFormData({
        oid_matriculado: participante.oid,
        oid_tematica: 1,
        participa: 1,
        fecha: dayjs()
      })
      form.setFieldsValue({
        oid_tematica: 1,
        participa: 1,
        fecha: dayjs()
      })
    }
    setErrors({})
  }, [asistencia, participante, open])

  const validateForm = () => {
    const newErrors = {}

    if (!formData.oid_tematica) {
      newErrors.oid_tematica = 'Debe seleccionar una temática'
    }

    if (!asistencia) {
      const existingAsistencia = participante.children?.find(
        a => a.oid_tematica === formData.oid_tematica
      )
      if (existingAsistencia) {
        newErrors.oid_tematica = 'Ya existe una asistencia para esta temática'
      }
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = async () => {
    try {
      if (!validateForm()) return

      const asistenciaData = {
        ...formData,
        fecha: formData.fecha.format('YYYY-MM-DD')
      }
      await onSave(asistenciaData)
    } catch (error) {
      console.error('Error al guardar asistencia:', error)
    }
  }

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }))
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: '' }))
    }
  }

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={asistencia ? 'Editar Asistencia' : 'Nueva Asistencia'}
      footer={[
        <Button key="cancel" onClick={onClose}>
          <FontAwesomeIcon icon={faTimes} className="mr-2" />
          Cancelar
        </Button>,
        <Button
          key="save"
          type="primary"
          onClick={handleSubmit}
          loading={loading}
        >
          <FontAwesomeIcon icon={faSave} className="mr-2" />
          {loading ? 'Guardando...' : 'Guardar'}
        </Button>
      ]}
    >
      <p className="text-sm text-gray-500 mb-4">
        Participante: {participante.nombre_matriculado}
      </p>

      <Form form={form} layout="vertical">
        <Form.Item
          label="Temática"
          name="oid_tematica"
          validateStatus={errors.oid_tematica ? 'error' : ''}
          help={errors.oid_tematica}
          rules={[{ required: true, message: 'Debe seleccionar una temática' }]}
        >
          <Select
            placeholder="Seleccionar temática"
            onChange={(value) => handleInputChange('oid_tematica', value)}
          >
            {tematicas.map((tematica) => {
              const hasAsistencia = participante.children?.some(
                a => a.oid_tematica === tematica.oid && (!asistencia || a.oid !== asistencia.oid)
              );
              return (
                <Select.Option
                  key={tematica.oid}
                  value={tematica.oid}
                  disabled={hasAsistencia}
                >
                  {tematica.nombre_tematica} {hasAsistencia && '(Ya registrada)'}
                </Select.Option>
              );
            })}
          </Select>
        </Form.Item>


        <Form.Item label="Participación" name="participa">
          <Select
            onChange={(value) => handleInputChange('participa', value)}
          >
            <Select.Option value={1}>Participó</Select.Option>
            <Select.Option value={0}>No participó</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item label="Fecha de la sesión" name="fecha">
          <DatePicker
            locale={locale}
            format="DD/MM/YYYY"
            value={formData.fecha}
            onChange={(date) => handleInputChange('fecha', date)}
            style={{ width: '100%' }}
            suffixIcon={<FontAwesomeIcon icon={faCalendarAlt} />}
          />
        </Form.Item>
      </Form>
    </Modal>
  )
}